module.exports = __webpack_public_path__ + "img/062.cc8b5ad0.png";